import React from "react";
import CountUp from "react-countup";
import "./KPICard478.css";

export default function KPICard({ title, value, suffix, color }) {
  return (
    <div className="kpi-card" style={{ borderTop: `4px solid ${color}` }}>
      <h4>{title}</h4>
      <p>
        <CountUp end={value} duration={2} decimals={1} suffix={suffix || "%"} />
      </p>
    </div>
  );
}
